// Configuration utility that supports both build-time and runtime configuration
class Config {
  constructor() {
    this.config = this.loadConfig();
  }

  loadConfig() {
    // Try to load runtime config first (if available)
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
      console.log('Using runtime configuration');
      return window.APP_CONFIG;
    }

    // Fallback to build-time environment variables
    console.log('Using build-time configuration');
    return {
      API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
      TELEGRAM_BOT_USERNAME: process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'npca_bot',
      TELEGRAM_AUTH_URL: process.env.REACT_APP_TELEGRAM_AUTH_URL || 'http://localhost:5001/api/auth/telegram'
    };
  }

  get(key) {
    return this.config[key];
  }

  getApiUrl() {
    return this.get('API_URL');
  }

  getTelegramBotUsername() {
    return this.get('TELEGRAM_BOT_USERNAME');
  }

  getTelegramAuthUrl() {
    return this.get('TELEGRAM_AUTH_URL');
  }

  // For debugging
  getAll() {
    return this.config;
  }
}

// Create singleton instance
const config = new Config();

export default config;
